module.exports = __webpack_public_path__ + "ff02f77863cf38acc16ade64b3191a3f.bg_inner-mobile.jpg";


//////////////////
// WEBPACK FOOTER
// ./components/background/assets/bg_inner-mobile.jpg
// module id = KO2S
// module chunks = 0